module.exports = __webpack_public_path__ + "img/upload-icon-white.70bc9fee.svg";